/**
 * Description: member接口
 * Author: sunc
 * Date: 2019-06-25
 * Time: 14:30
 */

export const memberApi = {
  // 用户登录V2
  loginV2: '/member/hubei/v2/login',
  // 用户注册信息校验v2
  memberRegValidV2: '/member/hubei/v2/register-valid',
  // 用户注册信息保存v2
  memberRegV2: '/member/hubei/v2/register',
  // 找回密码第一步
  findPsdNew1: '/member/hubei/find-psd-new1',
  // 找回密码第二步
  findPsdNew2: '/member/hubei/find-psd-new2',
  // 找回密码第三步
  findPsdNew3: '/member/hubei/find-psd-new3',
  // 用户登录
  login: '/member/hubei/login',
  // 获取用户信息
  getUserInfo: '/member/v1/account',
  //获取zzzx加密token
  zzzxUserInfo:'/member/hubei/public/automatToken/{guid}',
  //修改用户信息
  upDateUserInfo:'/member/v1/profile/member-entity',
  // 用户邮寄地址
  memEMSAddr: '/member/v1/bind/emsaddr',
  // 湖北用户邮寄地址
  memHbEMSAddr: '/member/hubei/bind/emsaddr',
  // 保存默认地址
  memEmsDefaultAddr: '/member/v1/bind/emsaddr/{guid}',
  // 用户短信登录
  loginSms: '/member/v1/log/sendsms',
  // 统计用户数量
  getUserCount: '/member/v1/count',
  // 用户注册发送短信
  memberRegSms: '/member/hubei/register/sms',
  // 用户注册
  memberReg: '/member/hubei/register',
  // 找回密码短信发送
  findPsdSms: '/member/hubei/find-psd-sms',
  // 找回密码
  findPsd: '/member/hubei/find-psd',
  // 统计用户访问量
  getUserVisit: '/member/v1/visit',
  // 获取用户头像
  portraitAtt: '/member/v1/portrait/att',
  // 裁剪用户头像
  portraitCut: '/member/v1/portrait/cut',
  //发送验证码
  loginSmsBus: '/member/v1/bus/sendsms',
  // 验证码校验
  loginVerBusCode: '/member/v1/verBusCode',
  // 忘记密码操作
  loginForget: '/member/v1/forget',
  //登录
  loginByPolice: '/member/v1/police/loginbyaccount',
  // 获取用户绑定的公司信息
  getCompany: '/member/v1/bind/comp',
  //绑定公司信息
  postCompany:'/member/v1/bind/comp',
  // 公安部登录
  loginGab: '/gab/member/v1/',
  // 获取用户的车辆信息
  memberCarInfo: '/member/v1/bind/cardinfo',
  //解绑用户车辆信息
  memberUnbindCar:'/member/v1/unbind/',
  // 绑定用户驾驶证
  memberDrive: '/member/v1/bind/drivercard',
  // 解绑用户驾驶证
  memberDriveUnbind: '/member/v1/unbind',
  //修改驾驶证信息
  memberDriveUpdate: '/member/v1/bind/drivercard',
  // 公司信息
  memberBindComp:  'member/v1/bind/comp',
  //修改密码
  memberPassword: '/member/v1/password',
  //注册
  memberRegister: '/member/v1/',
  // 忘记密码提交
  memberSmsVerCode: '/member/v1/verSms/verCode',
  // 重置密码
  memberResetPassword: '/member/v1/resetPassword',
  //用户绑定车辆
  memberBindCar: '/member/v1/bind/car',
  //短信登录
  loginMessage: '/member/v1/user/sendsms',
  //短信登录
  memberLoginMessage:'/member/v1/login/sms',
  //短信发送
  memberSendMessage:'/member/v1/update/sendsms',
  //更新电话号码
  memberUpdatePhone: '/member/v1/updatephone',
  //个人中心 -用户信息修改
  memberInfoUpdate: '/member/v1/profile/member-entity',
  // 交警122单点
  login122: '/member/hubei/police-h5/apply-url',

  // 生成临时用户
  genToken: '/member/v1/gen-token',

  // 重置密码
  resetPassword: '/member/hubei/repwd',
  userinfocheck: '/member/hubei/user/pwd',

  //注册第一步用户校验v3
  usercheck:'/member/hubei/v3/register1',
  //注册第二步，校验手机号，并发送短信验证码
  memberSms:'/member/hubei/v3/register2',
  //注册第三步，进行账号祖册
  userReg:'/member/hubei/v3/register3',
  //用户登陆V3
  memberLogin:'/member/hubei/v3/login',
  //新版验证码登录
  memberNewLogin:'/member/hubei/v3/new/login',
  //用户申诉 账号申诉-身份证被他人手机号占用 第一步
  memberAppealOne:'/member/hubei/v3/check/id-card',
  //用户申诉 账号申诉-身份证被他人手机号占用第二步
  memberAppealSec:'/member/hubei/v3/verify-bankcard',
  //用户申诉 账号申诉-身份证被他人手机号占用第三步
  memberAppealThir:'/member/hubei/v3/verify-sms',
  //用户申诉 账号申诉-身份证被他人手机号占用第四步
  memberAppealFur:'/member/hubei/v3/changePhone',
  //用户申诉 手机号被他人身份证占用  校验第一步，校验手机是否被注册
  memberTelAppealOne:'/member/hubei/v3/check/phone',
  //用户申诉 手机号被他人身份证占用  校验第二步，检验文件上传到省政府
  memberTelAppealSec:'/member/hubei/v3/upload/',
  //用户申诉 手机号被他人身份证占用  校验第三步，发送短信
  memberTelAppealThir:'/member/hubei/v3/sms',
  //用户申诉 手机号被他人身份证占用  校验第三步，申诉数据提交
  memberTelAppealFur:'/member/hubei/v3/appeal',
  //用户申诉 手机号被他人身份证占用  校验第er步，校验身份信息
  memberTelAppealFive:'/member/hubei/v3/name-auth',
  //根据账号判断是否存在该民警
  findUserByAccountId:'/member/hubei/police/police-exist',
  //黑名单二次核验接口
  memberAuthBlack:'/member/hubei/v3/black-list',
  //黑名单二次核验短信接口
  memberAuthBlackSms:'/member/hubei/v3/black-list/sms',

  szfFormLogin: '/member/hubei/szf-form/login',

//  法人注册第一步（判断法人是否注册自然人账号）
  legalPersonStep1:'/member/hubei/company/register1',
//  法人注册第二步（核验法人四要素）
  legalPersonStep2:'/member/hubei/company/register2',
//  法人注册第三步
  legalPersonStep3:'/member/hubei/company/register3',
//  法人注册短信
  legalPersonSms:'/member/hubei/company/sms',

}

